/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Assign_Track_CInputs */



/**
* | output |
* | --- |
* | "Assign Track C" |
*
* @param {Shortcut_Keys_Name_Assign_Track_CInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_assign_track_c = /** @type {((inputs?: Shortcut_Keys_Name_Assign_Track_CInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Assign_Track_CInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Attribuer la piste C")
	if (locale === "de") return /** @type {LocalizedString} */ ("Spur C zuweisen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assegna la traccia C")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Назначить дорожку C")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asignar pista C")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分配轨道 C")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トラックCを割り当てる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रैक C असाइन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atribuir a faixa C")
	return /** @type {LocalizedString} */ ("Assign Track C")
});